import Api from './api';

const portsOfArrivalListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/poas', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createPortOfArrivalRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/poas/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deletePortOfArrivalRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/poas/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { portsOfArrivalListRequest, createPortOfArrivalRequest, deletePortOfArrivalRequest }



// WEBPACK FOOTER //
// ./src/api/apiPortsOfArrival.js